import React from 'react';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useJWT } from '../../contexts/JWTProvider';
import { ServiceThemeOptions } from '../../themes';
import { createAnalyticsContext } from '../../utils/analytics';
import { SlackTracker } from '../../utils/slackNotifications';

interface DirectFooterProps {
  serviceName: string;
  primaryColor: string;
  footerBgColor?: string;
}

export default function DirectFooter({
  serviceName,
  primaryColor,
  footerBgColor = '#EEEFEF',
}: DirectFooterProps) {
  const jwt = useJWT();
  const theme = useTheme() as ServiceThemeOptions;

  return (
    <Box
      sx={{
        backgroundColor: footerBgColor,
        px: { xs: '16px', sm: '24px' },
        py: { xs: '12px', sm: '16px' },
        width: '100%',
        mt: 'auto',
        borderTop: `1px solid ${theme.palette?.divider || '#E0E0E0'}`,
        borderBottomLeftRadius: theme.shape?.borderRadius,
        borderBottomRightRadius: theme.shape?.borderRadius,
      }}
    >
      <Typography
        variant='caption'
        align='center'
        sx={{
          display: 'block',
          letterSpacing: '-0.15px',
          fontSize: { xs: '11px', sm: '14px' },
          lineHeight: { xs: '14px', sm: '15px' },
          fontWeight: 400,
        }}
      >
        By connecting your telematics account, you agree to the{' '}
        <a
          href='https://www.catenaclearing.io/legal/terms-of-service'
          target='_blank'
          rel='noreferrer'
          onClick={() => {
            const analyticsContext = createAnalyticsContext(jwt, serviceName);
            SlackTracker.termsClicked(analyticsContext);
          }}
          style={{ color: primaryColor, textDecoration: 'underline' }}
        >
          Terms of Service
        </a>{' '}
        and{' '}
        <a
          href='https://www.catenaclearing.io/legal/privacy-policy'
          target='_blank'
          rel='noreferrer'
          onClick={() => {
            const analyticsContext = createAnalyticsContext(jwt, serviceName);
            SlackTracker.privacyClicked(analyticsContext);
          }}
          style={{ color: primaryColor, textDecoration: 'underline' }}
        >
          Privacy Policy
        </a>
        .
      </Typography>
    </Box>
  );
}
